export default __webpack_public_path__ + "static/media/FULL-YOOZ-3DSecure-2-YOOZMusic.489045e4.mp4";